const styles = () => ({
  titleDivider: {
    border: '1px solid #FD6764',
    width: '40px',
  },
  contentText: {
    fontWeight: '500',
  },
  imageMobile: {
    height: '135px',
  },
  imageDesktop: {
    height: '177px',
  },
});

export default styles;
